import React from 'react';
import PropTypes from 'prop-types';
import provideTranslations from 'decorators/provideTranslations';

@provideTranslations('Icons')
class InfoIconContainer extends React.Component {
  render() {
    return <InfoIcon {...this.props} />;
  }
}

class InfoIcon extends React.Component {
  static propTypes = {
    color: PropTypes.string,
  };

  static contextTypes = {
    getString: PropTypes.func.isRequired,
  };

  static defaultProps = {
    color: '#007C8D',
  };

  render() {
    const { color } = this.props;
    const { getString } = this.context;

    return (
      <svg width="31px" height="31px" viewBox="0 0 31 31" xmlns="http://www.w3.org/2000/svg" aria-label={getString('AA_Info_Icon_Desc')}>
        <title>{getString('AA_Info_Icon_Title')}</title>
        <desc>{getString('AA_Info_Icon_Desc')}</desc>
        <g fill="none" fillRule="evenodd">
          <g fill="#007E8E">
            <path role="presentation" d="M14 7h3v3h-3zM14 13h3v10h-3z" />
          </g>
          <circle role="presentation" stroke={color} strokeWidth="3" cx="15.5" cy="15.5" r="14" />
        </g>
      </svg>
    );
  }
}

export default InfoIconContainer;
